import React from "react";
import { ExternalLink, ArrowUpRight } from "lucide-react";
import ProductMedia from "@/components/shop/ProductMedia";

export default function ProductListRow({ product }) {
  return (
    <a
      href={product.store_url}
      className="group flex items-center gap-6 py-6 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C8A96A]"
      data-testid={`product-row-${product.slug}`}
      aria-label={`Buy ${product.name} on our secure store`}
    >
      <div className="relative shrink-0">
        <ProductMedia product={product} className="w-24 h-24 rounded-sm" />
        <span className="absolute inset-0 flex items-center justify-center bg-[#1E2A44]/70 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-sm">
          <ExternalLink size={18} className="text-[#D8BE87]" />
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="overline mb-1">{product.collection_name}</p>
        <h3 className="font-serif text-xl text-[#1E2A44] truncate">{product.name}</h3>
        <p className="text-sm text-[#85827D]">{product.presentation}</p>
      </div>
      {product.price != null ? (
        <span className="hidden sm:inline text-lg font-semibold text-[#1E2A44]">${Number(product.price).toFixed(2)}</span>
      ) : (
        <span className="hidden sm:inline-flex items-center gap-1 text-xs text-[#85827D]">
          View live pricing <ArrowUpRight size={12} className="text-[#C8A96A]" />
        </span>
      )}
      <span
        className="inline-flex items-center gap-1.5 bg-[#1E2A44] text-white text-xs font-medium px-4 py-2.5 rounded-sm group-hover:bg-[#111C32] transition-colors shrink-0"
        data-testid={`row-buy-${product.slug}`}
      >
        Buy on Store <ExternalLink size={13} className="text-[#D8BE87]" />
      </span>
    </a>
  );
}
